import { App, URLOpenListenerEvent } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'

export const initApp = () => {
  const router = useRouter()

  App.addListener('backButton', () => {
    window.history.length > 0 ? router.back() : router.push({ name: 'app'})
  })

  App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    const originalUrl = event.url
    
    if (originalUrl.includes(useRuntimeConfig().public.APP_URL)) {
      const url = originalUrl.replace(useRuntimeConfig().public.APP_URL, '')
      router.push(url)
    }
    
    return 
  })
}

export const getVersion = async () => {
  const info = Capacitor.isNativePlatform() ? await App.getInfo() : { version: useRuntimeConfig().public.VERSION_WEB}

  return info?.version ?? null
}

export const getAppVersion = () => {
  const version: Ref<null | string> = ref(null)

  const fetchVersion = async () => {
    const info = await getVersion()
    version.value = info
  }

  fetchVersion()
  
  return { version }
}